const Unauthorized = () => {
  return (
    <div className="main">
      <h1 className="title">Unauthorized</h1>
    </div>
  );
};

export default Unauthorized;
